import { Injectable } from '@angular/core';
import {Patient} from "../models/patient.model";

@Injectable()
export class CurrentPatientService {

  patient: Patient;

  constructor() {
  }

  set(patient: Patient) {

    this.patient = new Patient(patient);
  }

  get() {
    return new Patient(this.patient);
  }

  reset() {
    this.patient = null;
  }
}



// WEBPACK FOOTER //
// ./src/services/currentPatient.ts